export default __webpack_public_path__ + "static/media/heart-outline.e21ad10d.svg";